export const getters = {
  getFormData: (state) => {
    return state.formData;
  },
};
